// extracted by mini-css-extract-plugin
module.exports = {"Layout":"Layout__Layout__2C2_c"};